<template>
  <div>
    <section
      class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    >
      <div class="title">עדכון סוג תור</div>
      <a
        class="m_bt_head head_go_back flex m-flex--center is-svg-w"
        href=""
        @click.prevent="goBack"
      >
        <ArrowBackSvgMobile />
      </a>
      <a class="m_bt_head head_save" href="" @click.prevent="saveApp">שמירה</a>
    </section>
    <ValidationObserver ref="newAppointmentForm">
      <form
        @submit.prevent="saveApp"
        v-promise-btn="{ action: 'submit' }"
        name="appointmentForm"
        autocomplete="off"
      >
        <section class="add_new_inner">
          <h2 class="subtitle_inner">
            יש לבחור סוג תור:
          </h2>
          <div class="filter_select">
            <validation-provider rules="required" name="insurance">
              <select2 name="insurance" v-model="appointment_type">
                <option value="">בחרו סוג תור</option>
                <option
                  v-for="block in filteredBlocks"
                  :key="block"
                  :value="block"
                  >{{ block }}</option
                >
              </select2>
              <div class="note">בחרו שילוב של סוג התור וסוג ביטוח</div>
            </validation-provider>
          </div>
        </section>
        <section class="add_new_inner">
          <h2 class="subtitle_inner">
            באפשרותך לבחור מועד באופן ידני או מתוך רשימת תורים פנויים:
          </h2>
          <div class="inner_group bg--white">
            <div class="add_new_row flex">
              <div class="add_new_row_col1">תאריך תור*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="datetime"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      type="text"
                      class="datepicker"
                      name="datetime"
                      placeholder="DD-MM-YYYY"
                      v-model="selectedDate"
                      autocomplete="off"
                    />
                  </div>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">משך תור (בדקות)*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="appointment_length"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      type="tel"
                      name="appointment_length"
                      v-model="selectedDuration"
                    />
                  </div>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="add_new_row flex">
              <div class="add_new_row_col1">שעה*</div>
              <div class="add_new_row_col2">
                <validation-provider
                  name="time"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <input
                      type="time"
                      name="time"
                      v-model="selectedTime.time"
                    />
                  </div>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="error note-error " v-if="invalidTime">
              לא ניתן לזמן תור , נסה שעה שונה
            </div>
          </div>
          <h2 class="subtitle_inner">תורים פנויים:</h2>
          <div class="book_hours_wrap inner_group bg--white">
            <div
              class="add_new_row flex"
              v-for="(date, index) in activeDates"
              :key="index"
            >
              <div class="add_new_row_col1">
                {{ index
                }}<span class="block">{{
                  $moment(index, "DD/MM/YYYY").format("יום ddd")
                }}</span>
              </div>
              <div class="book_hours_slide flex flex--start">
                <swiper
                  ref="hoursSlider"
                  :options="swiperOptions"
                  dir="rtl"
                  :auto-update="true"
                  :auto-destroy="true"
                  :delete-instance-on-destroy="true"
                  :cleanup-styles-on-destroy="true"
                >
                  <swiper-slide v-for="time in date" :key="time.time">
                    <a
                      class="book_hure ease"
                      href="javascript:void(0)"
                      @click.prevent="selectTime($event, time, index)"
                      >{{ time.time }}</a
                    >
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>

          <input
            type="hidden"
            name="selected_date"
            v-model="appointment.selectedDate"
          />
          <div class="form_submit center">
            <button class="bt_blue" type="submit">שמירה</button>
          </div>
        </section>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import HoursPop from "@/components/Popups/Hours";
import mixins from "../mixins/mixins.js";
import { mapGetters, mapState } from "vuex";
import Error from "@/components/Popups/Error";
import ArrowBackSvgMobile from "../assets/img/svg/arrow_back.svg";

export default {
  name: "AppTypeUpdate",
  mixins: [mixins],
  data() {
    return {
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: false
      },
      blocks: "",
      appointment_id: "",
      block_id: "",
      time_stamp: "",
      activeDates: {},
      selectedDate: "",
      selected_block: {},
      selectedTime: "",
      selectedDuration: "",
      invalidTime: false,
      appointment: {},
      filteredBlocks: [],
      appointment_type: ""
    };
  },
  beforeCreate() {},
  mounted() {
    let times_arr = {};
    this.$API.getAppointmentInfo(this.$route.params.id).then(res => {
      this.appointment = res.message.appointment;
      this.doctor = res.message.doctor;
      this.documents = res.message.documents;
      this.appointment_type =
        this.appointment.type + "-" + this.appointment.insurance;
      this.$API
        .getScheduleTable(this.doctor.id)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.blocks = res.data;
            this.blocks.map(block => {
              let key = block.appointment_type + "-" + block.insurance;
              if (!this.filteredBlocks.includes(key)) {
                this.filteredBlocks.push(key);
              }
            });
            this.$nextTick(() => {
              this.blocks.map(block => {
                if (
                  block.appointment_type == this.appointment.type &&
                  block.insurance == this.appointment.insurance
                ) {
                  let availableTimes = block.available_time_slots_array;
                  for (const index in availableTimes) {
                    const slot = this.$moment(
                      availableTimes[index][0],
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    const parsedDate = slot.format("DD/MM/YYYY");
                    const parseTime = slot.format("HH:mm");
                    if (!times_arr.hasOwnProperty(parsedDate)) {
                      times_arr[parsedDate] = [];
                      this.$set(times_arr, parsedDate, []);
                    }
                    let object = {
                      id: availableTimes[index][4],
                      time: parseTime
                    };
                    if (
                      typeof times_arr[parsedDate].find(
                        t => t.id === object.id
                      ) == "undefined"
                    ) {
                      times_arr[parsedDate].push(object);
                    }
                  }
                }
              });
              this.activeDates = times_arr;
            });
          }
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    });
  },
  methods: {
    saveApp() {
      return new Promise((resolve, reject) => {
        this.$refs.newAppointmentForm.validate().then(res => {
          if (res) {
            let date = this.$moment(
              this.selectedDate + " " + this.selectedTime.time,
              "DD/MM/YYYY LT"
            );

            this.$API
              .reScheduleAppointment(
                this.appointment.id,
                this.selectedTime.id,
                date.format("YYYY-MM-DD LT:00")
              )
              .then(res => {
                resolve();
                this.goBack();
              })
              .catch(e => {
                this.$modal.show(Error);
              });
          }
        });
      });
    },
    selectTime($event, time, date) {
      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(block => block.block_date == date);
      let parseddate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-D");
      let parsedtime = this.$moment(parseddate + "T" + time.time);
      this.selected_block = selectedBlock;
      let start_datetime = this.$moment(this.appointment.start_datetime);
      let end_datetime = this.$moment(this.appointment.end_datetime);
      let duration = end_datetime.diff(start_datetime, "m");
      this.selectedDuration = duration;
      this.selectedTime = time;
      this.selectedDate = date;
      let time_elm = document.getElementsByClassName("book_hure");
      for (let i in time_elm) {
        if (time_elm[i].classList && time_elm[i].classList.contains("active")) {
          time_elm[i].classList.remove("active");
        }
      }
      $event.target.classList.add("active");
    },
    openPopHours() {
      this.$modal.show(HoursPop);
    },
    parseDate(date) {},
    getTimes(date) {
      let active_times = this.activeTimes;

      let parsedDate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-D");

      let timesObject = {};

      for (let key in active_times) {
        if (key == parsedDate) {
          if (
            typeof timesObject[key] == "undefined" &&
            timesObject[key] !== active_times[key]
          ) {
            timesObject[key] = Object.values(active_times[key]);
          }
        }
      }
      return Object.values(timesObject)[0];
    },
    appointmentAbort() {
      this.$API
        .appointmentAbortLock(this.appointment_id)
        .then(res => {})
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  computed: {
    ...mapGetters(["currentStep", "patient"]),
    ...mapState(["Appoitments"]),
    availableTimes() {
      var times_arr = [];
      if (this.Appoitments) {
        let blocks = this.Appoitments.selectedBlock;

        if (blocks) {
          blocks.map(block => {
            let availableTimes = block.available_time_slots_array;
            for (const index in availableTimes) {
              const slot = this.$moment(
                availableTimes[index][0],
                "YYYY-MM-DD HH:mm:ss"
              );
              const parsedDate = slot.format("DD/MM/YYYY");
              const parseTime = slot.format("HH:mm");
              if (!times_arr.hasOwnProperty(parsedDate)) {
                times_arr[parsedDate] = [];
              }
              let object = {
                id: availableTimes[index][4],
                time: parseTime
              };
              times_arr[parsedDate].push(object);
            }
          });
        }

        return times_arr;
      }
      return false;
    }
  },
  watch: {
    appointment_type(newValue, oldValue) {
      if (newValue != oldValue) {
        let times_arr = {};
        let type_arr = newValue.split("-");
        let type = type_arr[0];
        let insurance = type_arr[1];
        let appointment = {
          block_id: this.appointment.surgery_block_id,
          datetime: this.$moment(this.appointment.start_datetime).format(
            "YYYY-MM-DTHH:mm:ss"
          ),
          appointment_id: this.appointment.id,
          first_name: this.appointment.firstName,
          last_name: this.appointment.lastName,
          passport: this.appointment.passport,
          phone: this.appointment.phone,
          second_phone: this.appointment.second_phone,
          appointment_duration_min: this.$moment(
            this.appointment.end_datetime
          ).diff(this.$moment(this.appointment.start_datetime), "minutes"),
          email: "",
          birth_date: this.appointment.birthDate,
          notes: this.appointment.notes,
          appointment_type: type,
          insurance: insurance,
          payment_method: this.appointment.payment_method
        };
        this.$API
          .scheduleAppointment(appointment, "update")
          .then(res => {})
          .catch(e => {
            this.$modal.show(Error);
          });
        this.activeDates = {};
        this.blocks.map(block => {
          if (block.appointment_type == type && block.insurance == insurance) {
            let availableTimes = block.available_time_slots_array;
            for (const index in availableTimes) {
              const slot = this.$moment(
                availableTimes[index][0],
                "YYYY-MM-DD HH:mm:ss"
              );
              const parsedDate = slot.format("DD/MM/YYYY");
              const parseTime = slot.format("HH:mm");
              if (!times_arr.hasOwnProperty(parsedDate)) {
                times_arr[parsedDate] = [];
                this.$set(times_arr, parsedDate, []);
              }
              let object = {
                id: availableTimes[index][4],
                time: parseTime
              };
              if (
                typeof times_arr[parsedDate].find(t => t.id === object.id) ==
                "undefined"
              ) {
                times_arr[parsedDate].push(object);
              }
            }
          }
        });
        this.activeDates = times_arr;
      }
    }
  },
  components: {
    ArrowBackSvgMobile
    // CloseSvg,
    // UploadSvg
  }
};
</script>

<style scoped>
.book_hours_slide {
  padding-left: 0px;
}
.swiper-container {
  width: 100%;
}
.error.note-error {
  color: #b00020;
  border-top: 2px solid;
}
</style>
